import axios from "axios";
import qs from "qs";
const { API_BACKEND_HOST } = process.env;
const responseFormat = { error: "", data: null };

export const getAll = async (filters) => {
  try {
    const languageId = localStorage.getItem("i18nextLng");

    const { data } = await axios.get(
      `${API_BACKEND_HOST}${languageId}/v1/Ata/filters`,
      {
        params: filters,
        paramsSerializer: (params) => {
          return qs.stringify(params);
        },
      }
    );

    return data;
  } catch ({ response }) {
    responseFormat.error = "async";

    return responseFormat;
  }
};

export const getById = async (id) => {
  try {
    const languageId = localStorage.getItem("i18nextLng");

    const { data } = await axios.get(
      `${API_BACKEND_HOST}${languageId}/v1/Ata/actions/${id}`
    );

    return data;
  } catch ({ response }) {
    responseFormat.error = "async";

    return responseFormat;
  }
};

export const createAction = async ({
  id,
  requesterId,
  firstResponsibleId,
  secoundResponsibleId,
  actionDecription,
  actionNumber,
  deadline,
  anyoneCanRequest,
}) => {
  const languageId = localStorage.getItem("i18nextLng");

  try {
    const { data } = await axios.post(
      `${API_BACKEND_HOST}${languageId}/v1/Ata/actions/${id}`,
      {
        requesterId,
        firstResponsibleId,
        secoundResponsibleId,
        actionDecription,
        actionNumber,
        deadline,
        anyoneCanRequest,
      }
    );

    return data;
  } catch (e) {
    return { error: true, message: e || "error" };
  }
};

export const createActionReviewOnFinishedMinute = async ({
  actionId,
  firstResponsibleId,
  reviewRequester,
  secoundResponsibleId,
}) => {
  const languageId = localStorage.getItem("i18nextLng");

  try {
    const { data } = await axios.patch(
      `${API_BACKEND_HOST}${languageId}/v1/Ata/actions/${actionId}/responsible`,
      {
        firstResponsibleId,
        reviewRequester,
        secoundResponsibleId,
      }
    );

    return data;
  } catch (e) {
    return { error: true, message: e || "error" };
  }
};

export const createActionReview = async ({
  actionId,
  member_Requester,
  member_Responsible1,
  member_Responsible2,
  description,
  anyoneCanRequest,
  actionNumber,
  deadline,
  member_Requester_Reviewer,
  member_Reviewer,
}) => {
  const languageId = localStorage.getItem("i18nextLng");

  try {
    const { data } = await axios.put(
      `${API_BACKEND_HOST}${languageId}/v1/Ata/actions/${actionId}`,
      {
        member_Requester,
        member_Responsible1,
        member_Responsible2,
        description,
        anyoneCanRequest,
        actionNumber,
        deadline,
        member_Requester_Reviewer,
        member_Reviewer,
      }
    );

    return data;
  } catch (e) {
    return { error: true, message: e || "error" };
  }
};

export const deleteAction = async (id) => {
  const languageId = localStorage.getItem("i18nextLng");

  try {
    const { data } = await axios.delete(
      `${API_BACKEND_HOST}${languageId}/v1/Ata/actions/${id}`
    );

    return data;
  } catch (e) {
    return { error: true, message: e || "error" };
  }
};

export const addGeneralComment = async ({ minuteSlotId, generalComments }) => {
  const languageId = localStorage.getItem("i18nextLng");

  try {
    await axios.post(
      `${API_BACKEND_HOST}${languageId}/v1/Ata/slot/GeneralComments`,
      {
        description: generalComments,
      },
      {
        params: {
          minuteSlotId,
        },
      }
    );

    return { success: "ok" };
  } catch (e) {
    return { error: true, message: e || "error" };
  }
};

export const addFinalDeliberation = async ({
  minuteSlotId,
  finalDeliberation,
}) => {
  const languageId = localStorage.getItem("i18nextLng");

  try {
    await axios.post(
      `${API_BACKEND_HOST}${languageId}/v1/Ata/slot/FinalDeliberation`,
      {
        description: finalDeliberation,
      },
      {
        params: {
          minuteSlotId,
        },
      }
    );

    return { success: "ok" };
  } catch (e) {
    return { error: true, message: e || "error" };
  }
};

export const addGeneralCommentRevision = async ({
  generalCommentsId,
  generalComments,
  memberRequesterReviewer,
  memberReviewer,
}) => {
  const languageId = localStorage.getItem("i18nextLng");

  try {
    await axios.put(
      `${API_BACKEND_HOST}${languageId}/v1/Ata/slot/GeneralComments`,
      {
        description: generalComments,
        member_Requester_Reviewer: memberRequesterReviewer,
        member_Reviewer: memberReviewer,
      },
      {
        params: {
          generalCommentsId,
        },
      }
    );

    return { success: "ok" };
  } catch (e) {
    return { error: true, message: e || "error" };
  }
};

export const addFinalDeliberationRevision = async ({
  finalDeliberationId,
  finalDeliberation,
  memberRequesterReviewer,
  memberReviewer,
}) => {
  const languageId = localStorage.getItem("i18nextLng");

  try {
    await axios.put(
      `${API_BACKEND_HOST}${languageId}/v1/Ata/slot/FinalDeliberation`,
      {
        description: finalDeliberation,
        member_Requester_Reviewer: memberRequesterReviewer,
        member_Reviewer: memberReviewer,
      },
      {
        params: {
          finalDeliberationId,
        },
      }
    );

    return { success: "ok" };
  } catch (e) {
    return { error: true, message: e || "error" };
  }
};

export const getMinutesParticipants = async (minuteId) => {
  const languageId = localStorage.getItem("i18nextLng");

  try {
    const { data } = await axios.get(
      `${API_BACKEND_HOST}${languageId}/v1/MinutesOfMeeting/participant`,
      {
        params: {
          idMinute: minuteId,
        },
      }
    );

    return { data };
  } catch (e) {
    return { error: true, message: e || "error" };
  }
};

export const setAttendances = async ({ participants, minuteId }) => {
  const languageId = localStorage.getItem("i18nextLng");

  try {
    const { data } = await axios.put(
      `${API_BACKEND_HOST}${languageId}/v1/MinutesOfMeeting/participant`,
      {
        participants,
      },
      {
        params: {
          idMinute: minuteId,
        },
      }
    );

    return { data };
  } catch (e) {
    return { error: true, message: e || "error" };
  }
};

export const updateMinuteStatus = async (minuteId, status) => {
  const languageId = localStorage.getItem("i18nextLng");
  const { data } = await axios.put(
    `${API_BACKEND_HOST}${languageId}/v1/Ata/Status/${minuteId}`,
    {},
    {
      params: {
        status,
      },
    }
  );

  return { data };
};

export const exportMinuteFile = async (minuteId, companyIds) => {
  const languageId = localStorage.getItem("i18nextLng");

  const response = await axios.get(
    `${API_BACKEND_HOST}${languageId}/v1/Ata/MinuteReport/${minuteId}`,
    {
      responseType: "blob",
      params: {
        companyId: companyIds,
      },
      paramsSerializer: (params) => {
        return qs.stringify(params);
      },
    }
  );

  return response;
};
